import * as types from "./types";
import { updateObject } from "../utility";

const initialState = {
  isSendingEmail: false,
  emailSentSuccess: false,
  forgotPasswordError: "",
};

const setIsSendingEmail = (state, action) => {
  return updateObject(state, {
    isSendingEmail: action.payload,
  });
};

const setEmailSentSuccess = (state, action) => {
  return updateObject(state, {
    emailSentSuccess: action.payload,
  });
};

const setForgotPasswordError = (state, action) => {
  return updateObject(state, {
    forgotPasswordError: action.payload,
  });
};

const forgotPasswordReducers = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.IS_SENDING_EMAIL:
      return setIsSendingEmail(state, action);
    case types.EMAIL_SENT_SUCCESS:
      return setEmailSentSuccess(state, action);
    case types.FORGOT_PASSWORD_ERROR:
      return setForgotPasswordError(state, action);
    default:
      return state;
  }
};

export default forgotPasswordReducers;
